import { useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { MoonIcon } from '../../assets/moon';
import { SunIcon } from '../../assets/sun';
import global from '../../assets/global.svg';
import globalWhite from '../../assets/global-white.svg';

import { Container, Content, LinksContainer, NavbarExtendedContainer, NavbarLink, NavbarLinkExtended, OpenLinksButton } from './styles';

interface Props {
  toggleTheme: () => void;
  toggleLanguage: () => void;
}

const mountedStyle = { animation: "inAnimation 0.6s ease-in" };

export function Header({ toggleTheme, toggleLanguage }: Props) {
  const { t } = useTranslation();
  const { title } = useContext(ThemeContext);

  const [extendNavbar, setExtendNavbar] = useState(false);

  function handleClick(e: any) {
    e.querySelector().scrollIntoView();
  }

  return (
    <>
      <Container extendNavbar={extendNavbar} id='home'>

        <Content>
          <OpenLinksButton
            onClick={() => {
              setExtendNavbar(!extendNavbar);
            }}
          >
            {extendNavbar ? <>&#10005;</> : <> &#8801;</>}
          </OpenLinksButton>

          <h2> Gabriel </h2>

          <LinksContainer>
            <NavbarLink to="#home" onClick={e => handleClick(e)}>Home</NavbarLink>
            <NavbarLink to="#aboutMe" onClick={e => handleClick(e)}>{t("aboutMe")}</NavbarLink>
            <NavbarLink to="#projects" onClick={e => handleClick(e)}>{t('projects')}</NavbarLink>
            <NavbarLink to="#contact" onClick={e => handleClick(e)}>{t('contact')}</NavbarLink>
          </LinksContainer>

          <div className='change-state-buttons'>
            <button className='theme' onClick={toggleTheme}>
              {title === 'dark' ?
                <SunIcon color="#FFF" />
                :
                <MoonIcon color="#222" />
              }
            </button>
            <button className='language' onClick={toggleLanguage}>
              {title === 'dark' ?
                <img src={globalWhite} />
                :
                <img src={global} />
              }
            </button>
          </div>
        </Content>

        {extendNavbar && (
          <NavbarExtendedContainer style={mountedStyle}>
            <NavbarLinkExtended to="#home" onClick={e => handleClick(e)}>Home</NavbarLinkExtended>
            <NavbarLinkExtended to="#aboutMe" onClick={e => handleClick(e)}>{t("aboutMe")}</NavbarLinkExtended>
            <NavbarLinkExtended to="#projects" onClick={e => handleClick(e)}>{t('projects')}</NavbarLinkExtended>
            <NavbarLinkExtended to="#contact" onClick={e => handleClick(e)}>{t('contact')}</NavbarLinkExtended>
          </NavbarExtendedContainer>
        )}
      </Container>
    </>
  )
}